import { FallbackLng } from "i18next";

export const languages = ["nb-NO", "nn-NO", "en-US"];

export const fallbackLanguages: FallbackLng = {
  "en-US": ["en"],
  "nb-NO": ["no", "en"],
  "nn-NO": ["no", "en"],
};
